import React from 'react';
import { CandidateRegisterProvider } from './candidate-register.provider';
import { CandidateRegister } from './candidate-register.view';

type CandidateRegisterFeatureProps = {
   captchaKey: string | null;
};

export const CandidateRegisterFeature = ({ captchaKey }: CandidateRegisterFeatureProps) => (
   <CandidateRegisterProvider>
      <CandidateRegister captchaKey={captchaKey} />
   </CandidateRegisterProvider>
);
